import { render, staticRenderFns } from "./ActiveSubscriptions.vue?vue&type=template&id=1280c392&scoped=true&"
import script from "./ActiveSubscriptions.vue?vue&type=script&lang=js&"
export * from "./ActiveSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./ActiveSubscriptions.vue?vue&type=style&index=0&id=1280c392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280c392",
  null
  
)

export default component.exports